// Client for the Morning Brief "Today's Opportunity" drill-down and its streamed AI explanation (/api/brief/opportunity).
import { headers, parse } from "./classificationApi";
import { streamFrom } from "./searchApi";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/brief/opportunity`;

export const OPP_MODEL = "Claude Sonnet 5.5";
export const opportunityFacts = () => fetch(BASE, { headers: headers(null, false) }).then(parse);
export const streamExplain = (fresh, handlers) => streamFrom(`${BASE}/explain`, { fresh }, handlers);
export const streamOppFollowUp = (id, q, handlers) => streamFrom(`${BASE}/${id}/followup`, { q }, handlers);

export const col = (name, a = 1) => `rgb(var(--${name}) / ${a})`;
export const nActions = (c) => `${Number(c).toLocaleString("en-PH")} action${c === 1 ? "" : "s"}`;
export const ENGINE_TONE = {
  demand_forecast: "info", stockout_adjusted: "muted", inventory_health: "warning", stockout_risk: "critical",
  replenishment: "primary", redistribution: "success", aging: "accent",
};
export const FAMILY_TONE = { protect: "critical", free: "warning", move: "success", buy: "primary" };

const SECTION = { SUMMARY: "summary", DRIVER: "drivers", FIRST: "first", CAUTION: "cautions", CHANGE: "change" };

// "SUMMARY / DRIVER / FIRST / CAUTION / CHANGE: …" lines → sections (lines without a prefix stay in the current section).
export function parseExplain(text) {
  const out = { summary: "", drivers: [], first: [], cautions: [], change: [] };
  let sec = "summary";
  const lines = (text || "").split("\n");
  lines.forEach((raw, idx) => {
    let line = raw.trim();
    if (!line || (idx === lines.length - 1 && /^[A-Z]{1,9}$/.test(line))) return;
    const m = /^(SUMMARY|DRIVERS?|FIRST|CAUTIONS?|CHANGE)\s*:\s*(.*)$/i.exec(line);
    if (m) {
      sec = SECTION[m[1].toUpperCase().replace(/(DRIVER|CAUTION)S$/, "$1")];
      line = m[2].trim();
      if (!line) return;
    }
    if (sec === "summary") out.summary = out.summary ? `${out.summary} ${line}` : line;
    else if (sec === "first") {
      const p = /^(HIGH|MEDIUM|LOW)\s*[-–—:]\s*(.*)$/i.exec(line);
      out.first.push(p ? { level: p[1].toUpperCase(), text: p[2] } : { level: null, text: line });
    } else out[sec].push(line);
  });
  return out;
}
